import React from 'react';
import {
  Modal,
  Row,
  Col,
  Tooltip,
  OverlayTrigger,
  Glyphicon,
} from 'react-bootstrap';
import {
  Button,
} from '../../../form/FormControls.jsx';
import { fromJS, List, Map } from 'immutable';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import JsonTable from 'react-json-table';
import { connect } from 'react-redux';
import { loadAuditList, clearAuditStore } from '../store/deal.store';
import { TableOptions } from '../../../../util/util.jsx';
import momentLocalizer from 'react-widgets-moment';
import moment from 'moment';
import AvailableSince, { VERSIONS } from '@/util/version';
import fieldFormatter, { fieldValueFormatter } from './fieldFormatter';
import { formatNumber } from '../elements/BaseElement';
moment.locale('en');
momentLocalizer();

const mapStateToProps = state => ({
  getAudit: () => state.getIn(['data', 'deals', 'deal', 'audit'], new Map()),
  getMetadata: () => state.getIn(['metadata', 'data']),
});

const mapDispatchToProps = dispatch => ({
  loadAuditList(module, id) {
    loadAuditList(dispatch, module, id);
  },
  clearAudit() {
    clearAuditStore(dispatch);
  },
});

const darkerColor = (color, ratio) => {
  const r = (((color >> 16) & 0xFF) * ratio);
  const g = (((color >> 8) & 0xFF) * ratio);
  const b = ((color & 0xFF) * ratio);
  return (r << 16) | (g << 8) | b;
};

const intToColor = (i) => {
  let hex = ((i >> 16) & 0xFF).toString(16) +
    ((i >> 8) & 0xFF).toString(16) +
    (i & 0xFF).toString(16);
  hex += '000000';
  return `#${hex.substring(0, 6)}`;
};

function getJsonTableSettings() {
  return {
    cellClass() {
      return 'json-table-td';
    },
    headerClass() {
      return 'hide';
    },
  };
}

const jsonTableCaptionStyle = { height: '30px',
  display: 'flex',
  alignItems: 'center',
  padding: '6px 13px' };

const COLLECTION_CAPTIONS_IGNORE = [
  'ru.sggr.starter.deal.compositeproduct.CompositeProduct.product',
  'ru.sggr.starter.deal.compositeproduct.CompositeProduct.packing',
];

class AuditClass extends React.Component {
  constructor(props) {
    super(props);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.resolveFieldLabel = this.resolveFieldLabel.bind(this);
    this.cellProperty = this.cellProperty.bind(this);
    this.cellOverlay = this.cellOverlay.bind(this);
    this.renameAction = this.renameAction.bind(this);
    this.dateFormat = this.dateFormat.bind(this);
    this.userFormat = this.userFormat.bind(this);
    this.changesFormat = this.changesFormat.bind(this);
    this.getEntityId = this.getEntityId.bind(this);
    this.navigateAuditItem = this.navigateAuditItem.bind(this);
    this.isShowAuditItem = this.isShowAuditItem.bind(this);
    this.state = { showModal: false,
      entity: undefined,
      processedAudit: null,
      selectedEntityString: [] };
  }

  componentWillUpdate(props, state) {
    if (this.isAllAuditLoaded(props) && !state.processedAudit) {
      let processedAudit = new Map();

      const auditData = props.getAudit();
      auditData.forEach((moduleData, module) => {
        moduleData.forEach((anditDataForId, moduleId) => {
          const audit = [];
          if (anditDataForId) {
            anditDataForId.forEach((val) => {
              audit.push({
                id: val.get('audit').get('id'),
                userId: val.get('audit').get('userId'),
                user: val.get('audit').get('userName'),
                roles: val.get('audit').get('roles'),
                date: val.get('audit').get('timestamp'),
                action: this.renameAction(val.get('action')),
                type: val.get('type'),
                description: val.get('description'),
                objectId: val.get('objectId'),
                properties: (val.get('properties').size == 0 ||
                val.get('properties').get('changes').size) == 0
                  ? null
                  : val.get('properties'),
                collections: val.get('collections').size == 0
                  ? null
                  : val.get('collections'),
              });
            });
            processedAudit = processedAudit.set(`${module}#${moduleId}`, audit);
          }
        });
      });
      this.setState({ processedAudit });
    }
    if (!state.selectedEntityString.length && props.selectedEntityString) {
      this.state.selectedEntityString.push(props.selectedEntityString);
    }
  }

  getEntityType(props = this.props, state = this.state) {
    return (state.entity && state.entity.type) || props.entityType;
  }

  getEntityId(props = this.props, state = this.state) {
    return (state.entity && (state.entity.id || state.entity.id === 0)) || props.entityId;
  }

  /* eslint-disable */
  processRowProperty(action, containedData, data, nodeCollections, containerIds, itemDescriptions, entityString) {
    if (data) {
      containerIds = (containerIds || new List()).map(id => {
        const splitId = id.split('#');
        let containerId = splitId[0];
        if (splitId.length > 1) {
          containerId = `${splitId[0]}#${splitId[1]}`;
        }
        if (splitId.length > 2 && !itemDescriptions[containerId]) {
          itemDescriptions[containerId] = splitId[2];
        }
        return containerId;
      });
        const propertyResolvedContainer = `${data.get('type')}#${data.get('objectId')}`;
        if (!itemDescriptions[propertyResolvedContainer]) {
          itemDescriptions[propertyResolvedContainer] = (containedData && containedData.get('description'))
            || data.get('description');
        }

        const dataType = data.get('type');
        if (!containerIds.includes(propertyResolvedContainer)
          && !dataType.startsWith('ru.sggr.starter.dict.')
          && !dataType.startsWith('ru.sggr.starter.user.')) {
          containerIds = containerIds.push(propertyResolvedContainer);
        }

        if (containedData && containedData.get('field') && (dataType.startsWith('ru.sggr.starter.dict.')
          || dataType.startsWith('ru.sggr.starter.user.'))) {
          data = data.set('field', containedData.get('field'));
        }

        containerIds = containerIds.push('DEFAULT');
        return nodeCollections.setIn(containerIds.toArray(),
          nodeCollections.getIn(containerIds.toArray(), new List()).push(data.set('action', action)));
    }
    return nodeCollections;
  }
  /* eslint-enable */

  cutLevel(entityString) {
    if (entityString) {
      const selectedEntityStringSplit = entityString.split('#');
      if (['compositeproduct', 'port'].includes(selectedEntityStringSplit[0])) {
        return 1;
      }
    }
    return 0;
  }

  processRowCollection(data, nodeCollections, itemDescriptions, entityString) {
    const containerIds = data.get('containerIds', new List());

    // eslint-disable-next-line
    let nodeCollections_ = nodeCollections;
    if (containerIds.size) {
      data.get('changes', new List()).forEach((d) => {
        nodeCollections_ = this.processRowProperty(this.renameAction(data.get('action')),
          data, d, nodeCollections_, containerIds, itemDescriptions, entityString);
      });
    }
    return nodeCollections_;
  }

  changesFormat(empty, row, extraData) {
    if (row.properties === null && row.collections == null) return '';

    let nodeCollections = new Map();
    const itemDescriptions = {};

    if (row.properties) {
      row.properties.get('changes', new List())
        .forEach((data) => {
          nodeCollections = this.processRowProperty(this.renameAction(data.get('action')),
            null, data, nodeCollections, data.get('containerIds'), itemDescriptions, extraData);
        });
    }

    if (row.collections) {
      row.collections.forEach((data) => {
        nodeCollections = this.processRowCollection(data, nodeCollections,
          itemDescriptions, extraData);
      });
    }

    const columns = [
      { key: 'property', label: 'Property', cell: this.cellProperty },
      { key: 'before', label: 'Before', cell: this.cellOverlay },
      { key: 'after', label: 'After', cell: this.cellOverlay },
    ];

    const background = 0xffffff;

    if (this.state.selectedEntityString.length) {
      const entityId = extraData.split('#')[1];
      nodeCollections = nodeCollections.filter((v, k) => {
        const splitKey = k.split('#');
        if (splitKey.length > 1) {
          return entityId == splitKey[1];
        }
        return true;
      });
    }
    const unattachedDefaultNode = nodeCollections.get('DEFAULT');
    if (unattachedDefaultNode) {
      nodeCollections = nodeCollections.setIn(['topLevelNode', 'DEFAULT'], unattachedDefaultNode);
    }
    const tables = (<div>
      {this.showCollections(row.action, itemDescriptions, nodeCollections, columns, background, 0)}
    </div>);

    return (
      <div>
        <div>
          {tables}
        </div>
      </div>
    );
  }

  sectionCaption(itemDescriptions, key, background) {
    if (key == 'DEFAULT' || key == 'topLevelNode') {
      return '';
    }
    const splitKey = key.split('#');
    const itemDescription = itemDescriptions[key];
    let itemDescriptionString = '';
    if (itemDescription) {
      itemDescriptionString = `(${itemDescription})`;
    }
    if (splitKey[0].startsWith('ru.sggr.starter.dict')) {
      return '';
    }
    return (
      <div style={{ ...jsonTableCaptionStyle, background: intToColor(background) }}>
        {this.resolveFieldLabel(splitKey[0], '')}{'\u00A0'}{itemDescriptionString}
      </div>
    );
  }

  showCollections(action, itemDescriptions, nodeCollections, columns, background, padding) {
    return nodeCollections.map((value, key) => {
      const caption = this.sectionCaption(itemDescriptions, key, background);
      if (Map.isMap(value)) {
        const defaultValue = value.get('DEFAULT');
        let defaultValueNode = '';
        if (defaultValue && List.isList(defaultValue)) {
          defaultValueNode = (<div
            style={{ background: intToColor(background), marginRight: '-2px' }}
          >
            <JsonTable
              className="json-table"
              settings={getJsonTableSettings()}
              rows={this.mapChanges(defaultValue).filter(d =>
                !d.get('field').endsWith('predefine')).toJS()}
              columns={columns}
            />
          </div>);
        }
        let resolvedAction;
        if (defaultValue && defaultValue.size) {
          const firstValue = defaultValue.get(0);
          resolvedAction = `${firstValue.get('action', action)} 
            ${firstValue.get('elementName', '')}`;
        } else {
          resolvedAction = action;
        }

        // eslint-disable-next-line
        value = value.delete('DEFAULT');
        return (
          <div>
            <table style={{ marginLeft: padding, width: `calc(100% - ${padding}px)` }}>
              <tr>
                <td
                  className="json-table-td"
                  width={150 - padding}
                  style={{ borderTop: 0, textAlign: 'center', background: intToColor(background) }}
                >
                  {resolvedAction}
                </td>
                <td
                  className="json-table-td"
                  style={{
                    padding: 0,
                    borderTop: 0,
                    borderRight: 0 }}
                >
                  {caption}
                  {defaultValueNode}
                </td>
              </tr>
            </table>
            {this.showCollections(action, itemDescriptions, value, columns,
              darkerColor(background, 0.97), padding + 20)}
          </div>
        );
      }
      return '';
    });
  }

  isShowCollectionCaption(field) {
    return !COLLECTION_CAPTIONS_IGNORE.includes(field);
  }

  resolveFieldLabel(fieldName, description) {
    const field = fieldFormatter.get(fieldName);

    let captionStart = field;
    if (!field) {
      captionStart = fieldName.split('.').reverse()[0];
    }
    return `${captionStart} ${description ? `(${description})` : ''}`;
  }

  cellProperty(item) {
    return this.resolveFieldLabel(item.field);
  }

  cellOverlay(item, key) {
    const tooltip = (
      <Tooltip id="user"><p>{item[key]}</p></Tooltip>
    );
    const val = item[key];
    let result = val;
    if (val && val.trim && val.trim() && !isNaN(val)) {
      const split = (`${val}`).split('.');
      if (split[1]) {
        let zeros = '';
        for (const splitItem in split[1]) {  // eslint-disable-line
          zeros += '0';
        }
        result = formatNumber(val, `0,0.${zeros}`);
      } else {
        result = formatNumber(val);
      }
    }
    return (
      <OverlayTrigger placement="top" overlay={tooltip}>
        <span>{result}</span>
      </OverlayTrigger>
    );
  }

  renameAction(action) {
    switch (action) {
      case 'ADD':
        return 'Created';
      case 'MOD':
        return 'Edit';
      case 'DEL':
        return 'Deleted';
      default:
        return action;
    }
  }

  dateFormat(timestamp) {
    return moment(timestamp).toDate().toLocaleString();
  }

  userFormat(user, row) {
    const tooltip = (
      <Tooltip id="user"><p>{row.roles}</p></Tooltip>
    );
    return (<div>
      <OverlayTrigger placement="top" overlay={tooltip}>
        <Glyphicon glyph="info-sign" className="table-glyph" />
      </OverlayTrigger>
      {user}
    </div>);
  }

  mapChanges(changes) {
    return changes.sortBy(change => this.resolveFieldLabel(change.get('field')))
      .map(change => fromJS({
        field: change.get('field'),
        after: fieldValueFormatter(change.get('field'), change.get('after')),
        before: fieldValueFormatter(change.get('field'), change.get('before')),
      }));
  }

  closeModal() {
    this.setState({ showModal: false, selectedEntityString: [], processedAudit: null });
  }

  openModal() {
    this.updateAudit();
    this.setState({ showModal: true, selectedEntityString: [], processedAudit: null });
  }

  updateAudit(props = this.props) {
    props.clearAudit();
    if (props.group) {
      const { deal, allProducts, loadingPorts, dischargePorts } = props.group;
      if (deal) {
        props.loadAuditList(deal.module, deal.entity.get('id'));
      }
      const collectionLoad = (coll) => {
        if (coll) {
          coll.entities.filter(e => e.get('id')).forEach((e) => {
            props.loadAuditList(coll.module, e.get('id'));
          });
        }
      };
      collectionLoad(allProducts);
      collectionLoad(loadingPorts);
      collectionLoad(dischargePorts);
    } else if (props.module) {
      props.loadAuditList(props.module, props.entityId);
    }
  }

  auditTotalEntities(props = this.props) {
    let totalEnitities = 0;
    if (props.group) {
      const { deal, allProducts, loadingPorts, dischargePorts } = props.group;
      if (deal && deal.entity) {
        totalEnitities++;
      }

      const collectionInc = (coll) => {
        let inc = 0;
        if (coll && coll.entities) {
          coll.entities.forEach(() => inc++);
        }
        return inc;
      };
      totalEnitities += collectionInc(allProducts) + collectionInc(loadingPorts)
        + collectionInc(dischargePorts);
    } else if (props.module) {
      totalEnitities++;
    }
    return totalEnitities;
  }

  isAllAuditLoaded(props = this.props) {
    const totalAuditPending = this.auditTotalEntities(props);
    let totalLoadedAudit = 0;

    const auditData = props.getAudit();
    auditData.forEach((moduleData) => {
      totalLoadedAudit += moduleData.size;
    });
    return totalAuditPending > 0 && totalAuditPending == totalLoadedAudit;
  }

  entityString(entityInfo, item) {
    return `${entityInfo.module}#${item.get('id')}`;
  }

  navigateAuditItem(entityInfo, item) {
    const entityInfoString = this.entityString(entityInfo, item);
    if (this.state.selectedEntityString.includes(entityInfoString)) {
      this.setState({ selectedEntityString:
        this.state.selectedEntityString.filter(el => el != entityInfoString) });
    } else {
      this.state.selectedEntityString.push(entityInfoString);
      this.setState({ selectedEntityString: this.state.selectedEntityString });
    }
  }

  isShowAuditItem(entityInfo, item) {
    return this.state.selectedEntityString.includes(this.entityString(entityInfo, item));
  }

  render() {
    let component;
    const auditData = this.props.getAudit();

    const totalAuditPending = this.auditTotalEntities();
    let totalLoadedAudit = 0;
    auditData.forEach((moduleData) => {
      totalLoadedAudit += moduleData.size;
    });
    const { group = {} } = this.props;
    if (this.props.entityId === null && !this.props.group) {
      component = <center>Audit data doesn{'\''}t exist</center>;
    } else if (totalAuditPending > totalLoadedAudit) {
      component = <center>Loading... ({totalLoadedAudit}/{totalAuditPending})</center>;
    } else if (totalLoadedAudit == totalAuditPending && totalAuditPending > 0
        && this.state.showModal && this.state.processedAudit) {
      const allAudits = [];
      if (this.state.selectedEntityString.length) {
        const productEntSeq = group.allProducts && group.allProducts.entities
          && group.allProducts.entities.map(p => this.entityString(group.allProducts, p));
        const loadingPortsEntSeq = group.loadingPorts && group.loadingPorts.entities
          && group.loadingPorts.entities.map(p => this.entityString(group.loadingPorts, p));
        const dischargePortsEntSeq = group.dischargePorts && group.dischargePorts.entities
          && group.dischargePorts.entities.map(p => this.entityString(group.dischargePorts, p));

        [this.entityString(group.deal, group.deal.entity), ...(group.allProducts || []),
          ...(productEntSeq || []), ...(loadingPortsEntSeq || []),
          ...(dischargePortsEntSeq || [])].forEach((ent) => { // eslint-disable-next-line
          this.state.selectedEntityString.includes(ent) && allAudits.push({
            audit: this.state.processedAudit.get(ent),
            key: ent,
          });
        });
      } else if (this.props.module) {
        const key = `${this.props.module}#${this.props.entityId}`;
        allAudits.push({ audit: this.state.processedAudit
          .get(key),
        key });
      }
      component = (<div>
        {allAudits.map((auditObj) => {
          const audit = auditObj.audit || [];
          return (<center style={{ paddingTop: '15px' }}>
            <BootstrapTable
              data={audit}
              hover
              condensed
              pagination={audit.length > 10}
              options={{
                ...TableOptions,
              }}
            >
              <TableHeaderColumn
                dataField="date"
                width="125"
                dataFormat={this.dateFormat}
                dataSort
                isKey
              >
                Date
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="user"
                width="160"
                tdStyle={{ borderRight: 0 }}
                dataFormat={this.userFormat}
              >
                User
              </TableHeaderColumn>
              <TableHeaderColumn
                dataAlign="center"
                width="150"
                tdAttr={{ colSpan: '4' }}
                formatExtraData={auditObj.key}
                dataFormat={this.changesFormat}
                tdStyle={{ padding: 0, borderLeft: 0 }}
              >
                Action
              </TableHeaderColumn>
              <TableHeaderColumn
                dataAlign="center"
                tdStyle={{ display: 'none' }}
              >
                Property
              </TableHeaderColumn>
              <TableHeaderColumn
                dataAlign="center"
                tdStyle={{ display: 'none' }}
              >
                Before
              </TableHeaderColumn>
              <TableHeaderColumn
                dataAlign="center"
                tdStyle={{ display: 'none' }}
              >
                After
              </TableHeaderColumn>
            </BootstrapTable>
          </center>);
        })}
      </div>);
    }
    return (<AvailableSince version={VERSIONS.Kleoptoleme}>
      <div className={'audit-container'}>
        <Modal bsSize="large" show={this.state.showModal} onHide={this.closeModal}>
          <Modal.Header style={{ padding: '0px 30px' }}>
            <h4 style={{ float: 'left' }}>{this.props.title}</h4>
            <Button
              bsStyle="link" id="closeModal" onClick={this.closeModal}
              style={{ float: 'right', padding: '10px', color: 'lightgray' }}
            >
              <Glyphicon glyph="remove" />
            </Button>
          </Modal.Header>
          <Modal.Body style={{ padding: '10px 20px' }}>
            <Row>
              <Col md={12} style={{ paddingBottom: '10px' }}>
                {group.deal &&
                  <Button
                    bsStyle={this.isShowAuditItem(group.deal, group.deal.entity) ? 'primary' : ''}
                    onClick={() => this.navigateAuditItem(group.deal, group.deal.entity)}
                  >
                    <Glyphicon glyph="home" className="table-glyph" />
                  </Button>
                }
                {group.allProducts && group.allProducts.entities
                && group.allProducts.entities.map((product, idx) => (
                  <Button
                    bsStyle={this.isShowAuditItem(group.allProducts, product) ? 'primary' : ''}
                    onClick={() => this.navigateAuditItem(group.allProducts, product)}
                  >
                    {idx + 1}
                  </Button>
                ))
                }
                {group.loadingPorts && group.loadingPorts.entities
                  && group.loadingPorts.entities.map((port, idx) => (
                    <Button
                      bsStyle={this.isShowAuditItem(group.loadingPorts, port) ? 'primary' : ''}
                      onClick={() => this.navigateAuditItem(group.loadingPorts, port)}
                    >
                      {group.loadingPorts.prefix || ''}{idx + 1}
                    </Button>
                  ))
                }
                {group.dischargePorts && group.dischargePorts.entities
                && group.dischargePorts.entities.map((port, idx) => (
                  <Button
                    bsStyle={this.isShowAuditItem(group.dischargePorts, port) ? 'primary' : ''}
                    onClick={() => this.navigateAuditItem(group.dischargePorts, port)}
                  >
                    {group.dischargePorts.prefix || ''}{idx + 1}
                  </Button>
                ))
                }
              </Col>
              <Col md={12}>
                {component}
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.closeModal}>OK</Button>
          </Modal.Footer>
        </Modal>
        <Button bsStyle="link" style={this.props.buttonStyle} onClick={this.openModal}>
          {this.props.children}
        </Button>
      </div>
    </AvailableSince>);
  }
}
AuditClass.propTypes = {
  title: React.PropTypes.string,
  module: React.PropTypes.string,
  entityId: React.PropTypes.number,
  entityType: React.PropTypes.string,
  closeModal: React.PropTypes.func,
  openModal: React.PropTypes.func,
  getAudit: React.PropTypes.func,
  getMetadata: React.PropTypes.func,
  clearAudit: React.PropTypes.func,
  loadAuditList: React.PropTypes.func,
  children: React.PropTypes.object,
  buttonStyle: React.PropTypes.object,
  group: React.PropTypes.object,
  selectedEntityString: React.PropTypes.string,
};

export const Audit = connect(mapStateToProps, mapDispatchToProps)(AuditClass);
